<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      dark
      src="@/assets/img/bgDrawer.jpg"
    >
      <v-list>
        <v-list-item>
          <v-list-item-avatar>
            <img src="@/assets/img/logo.png" alt="Logo" />
          </v-list-item-avatar>
          <v-list-item-content>
            <!-- <v-list-item-title class="title">{{
              $keycloak.fullName
            }}</v-list-item-title>
            <v-list-item-subtitle
              >Account : {{ $keycloak.userName }}</v-list-item-subtitle
            > -->
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider />
      <v-list dense>
        <v-list-item
          v-for="([icon, text, link], i) in items"
          :key="i"
          link
          @click="link !== '#xxx' ? $vuetify.goTo(link) : ''"
          :href="link === '#xxx' ? 'https://my.muic.io/#/faq?topic=1' : ''"
          :target="link === '#xxx' ? '_blank' : ''"
        >
          <v-list-item-icon class="justify-center">
            <v-icon>{{ icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="subtitile-1">{{
              text
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider />
      <div class="text-center pt-3">
        <!-- <v-btn
          color="error"
          elevation="4"
          small
          :href="$keycloak.createLogoutUrl()"
          >Logout</v-btn
        > -->
      </div>
    </v-navigation-drawer>
    <v-app-bar
      app
      :color="color"
      :flat="flat"
      dark
      class="px-8"
      :class="{ expand: flat }"
    >
      <v-toolbar-title>
        <v-img src="@/assets/img/logo.png" max-width="95px" />
      </v-toolbar-title>
      <v-spacer />
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" class="" v-if="isXs" />
      <div v-else>
        <v-btn text @click="$vuetify.goTo('#intro')">
          <span class="mr-2">Home</span>
        </v-btn>
        <v-btn text @click="$vuetify.goTo('#download')">
          <span class="mr-2">Download</span>
        </v-btn>
        <!--  
          <v-btn text @click="$vuetify.goTo('#quiz')">
            <span class="mr-2">Quiz</span>
          </v-btn>
        -->
        <v-btn text @click="$vuetify.goTo('#help')">
          <span class="mr-2">Help</span>
        </v-btn>
        <v-btn text target="_blank" href="https://my.muic.io/#/faq?topic=1">
          <span class="mr-2">FAQ</span>
        </v-btn>
        <!-- <v-btn text>
          <v-menu bottom min-width="200px" rounded offset-y>
            <template v-slot:activator="{ on }">
              <v-btn icon x-large v-on="on">
                <v-avatar color="teal" size="48">
                  <span class="white--text text-h5">{{
                    $keycloak.fullName.substring(0, 2)
                  }}</span>
                </v-avatar>
              </v-btn>
            </template>
            <v-card>
              <v-list-item-content class="justify-center">
                <div class="mx-auto text-center">
                  <v-avatar color="teal" size="48">
                    <span class="white--text text-h5">{{
                      $keycloak.fullName.substring(0, 2)
                    }}</span>
                  </v-avatar>
                  <h4 class="mt-2 mb-1">{{ $keycloak.fullName }}</h4>
                  <p class="mt-1 mb-2">{{ $keycloak.tokenParsed.email }}</p>
                  <v-divider class="my-3"></v-divider>
                  <v-btn
                    depressed
                    rounded
                    text
                    :href="$keycloak.createLogoutUrl()"
                  >
                    Logout
                  </v-btn>
                </div>
              </v-list-item-content>
            </v-card>
          </v-menu>
        </v-btn> -->
      </div>
    </v-app-bar>
  </div>
</template>

<style scoped>
.v-toolbar {
  transition: 0.6s;
}
.expand {
  height: 80px !important;
  padding-top: 10px;
}
</style>

<script>
export default {
  data: () => ({
    drawer: null,
    isXs: false,
    items: [
      ["mdi-home-outline", "Home", "#intro"],
      ["mdi-download-box-outline", "Download", "#download"],
      // ["mdi-head-question", "Quiz", "#quiz"],
      ["mdi-information-outline", "Help", "#help"],
      ["mdi-help", "FAQ", "#xxx"],
    ],
  }),
  props: {
    color: String,
    flat: Boolean,
  },
  methods: {
    onResize() {
      this.isXs = window.innerWidth < 850;
    },
  },

  watch: {
    isXs(value) {
      if (!value) {
        if (this.drawer) {
          this.drawer = false;
        }
      }
    },
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
};
</script>
